import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { Layers, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/categories`).then(res => { setCategories(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const colors = [
    'from-teal-500/20 to-teal-500/5',
    'from-emerald-500/20 to-emerald-500/5',
    'from-cyan-500/20 to-cyan-500/5',
    'from-sky-500/20 to-sky-500/5',
    'from-blue-500/20 to-blue-500/5',
    'from-violet-500/20 to-violet-500/5',
    'from-pink-500/20 to-pink-500/5',
    'from-amber-500/20 to-amber-500/5',
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12" data-testid="categories-page">
      <div className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-2">Categories</h1>
        <p className="text-muted-foreground">Browse prompts by category</p>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-28 rounded-xl bg-muted animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="categories-grid">
          {categories.map((cat, i) => (
            <Link key={cat.id} to={`/?category=${cat.name}`} data-testid={`category-card-${cat.slug}`}>
              <Card className={`p-5 border-border/50 hover:-translate-y-1 hover:border-primary/50 transition-all duration-300 bg-gradient-to-br ${colors[i % colors.length]}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-semibold mb-1">{cat.name}</h3>
                    <p className="text-xs text-muted-foreground">{cat.slug}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-muted-foreground" />
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
